import {Axios} from "axios";
import {PageableDto} from "../pagination/PagingFilterDto";
import {SortableDto} from "../pagination/SortingFilterDto";
import {PageableResultListDto} from "../pagination/PageableResultListDto";

export interface IsdsMessageInfoDto {
    id: number;
    createTime?: Date;
    nextTryAfter?: Date;
    errorCount?: number;
    currentState?: IsdsMessageStateDto;

    priority?: number;
    numOfAttachments?: number;
    recipient?: string;
    annotation?: string;
}

export enum IsdsMessageState {
    IN_PROGRESS = "IN_PROGRESS",
    POSTPONED = "POSTPONED",
    SENT = "SENT",
    FAILED = "FAILED",
}

export interface IsdsMessageStateDto {
    messageId: string;
    type?: IsdsMessageState;
    changeTime?: Date;
    statusCode?: number;

    errorCode?: string;
    errorMessage?: string;
}

export interface IsdsMessageFilterDto extends PageableDto, SortableDto {
    currentStateType?: IsdsMessageState;
    currentStatusCode?: string;
    currentErrorCode?: string;

    createdSince?: string;
    createdTo?: string;

    prioritized?: string;
    recipient?: string;
}

export class IsdsMessageApiClient {

    constructor(private readonly axios: Axios) {
    }

    findById(messageId: number): Promise<IsdsMessageInfoDto | undefined> {
        return new Promise((resolve, reject) => {
            this.axios.get<IsdsMessageInfoDto | undefined>(`/messages/${messageId}`)
                .then((response) => resolve(response.data))
                .catch((error) => {
                    if (error?.response?.status === 404) {
                        resolve(undefined);
                    }
                    reject(error);
                });
        });
    }

    findByFilter(filter: IsdsMessageFilterDto): Promise<PageableResultListDto<IsdsMessageInfoDto>> {
        return new Promise((resolve, reject) => {
            this.axios.post<PageableResultListDto<IsdsMessageInfoDto>>("/messages:search", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    countByFilter(filter: IsdsMessageFilterDto): Promise<number> {
        return new Promise((resolve, reject) => {
            this.axios.post<number>("/messages:search-count", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

}
